import {CookieUtility} from "./CookieUtility";
import {MessageDisplayerUtility} from "./MessageDisplayerUtility";

export let AuthUtility = {
    userHasPermissions: function (requiredPermissions) {
        let userPermissions = CookieUtility.load("permissionNames") || [];

        for (let i = 0; i < requiredPermissions.length; i++) {
            let requiredPermission = requiredPermissions[i];
            if (!userPermissions.includes(requiredPermission)) {
                return false;
            }
        }

        return true;
    },

    userHasOneOfThesePermissions: function (requiredPermissions) {
        let userPermissions = CookieUtility.load("permissionNames") || [];

        for (let i = 0; i < requiredPermissions.length; i++) {
            let requiredPermission = requiredPermissions[i];
            if (userPermissions.includes(requiredPermission)) {
                return true;
            }
        }

        return false;
    },

    clearAuthCookies: function () {
        CookieUtility.remove("permissionNames");
    },

    userHasEnforcedPermissions: function (enforcedPermissions) {
        let userPermissions = CookieUtility.load("permissionNames") || [];

        for (let i = 0; i < enforcedPermissions.length; i++) {
            let requiredPermission = enforcedPermissions[i];
            if (!userPermissions.includes(requiredPermission)) {
                window.location.assign('/login');
                return false
            }
        }

        return true;
    }
};
